import ServiceCRUD from '../../../../services/ServiceCRUD';
import { apiCase as http } from '../../../../http';

class ProtocolSLAInfoService extends ServiceCRUD {
  constructor() {
    super('protocol-sla');
  }

  reCalculateSLATime(protocolId) {
    return http.get(`${this.path}/${protocolId}`);
  }

  canUserEditSLA(protocolId, userLogin) {
    return http.get(`${this.path}/verify/${protocolId}/${userLogin}`);
  }
}

export default new ProtocolSLAInfoService();
